import React from 'react';

const WHATSAPP_NUMBER = '5217621685475'; // Cambia por tu número con código de país
const WHATSAPP_MESSAGE = '¡Hola! Necesito ayuda con OmniCrud.';

const WhatsAppButton: React.FC = () => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Contactar por WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="32"
          height="32"
          fill="white"
        >
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.833.738 5.495 2.031 7.807L0 32l8.418-2.01A15.934 15.934 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.766-1.848l-.485-.29-5 1.194 1.224-4.867-.317-.5A13.267 13.267 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.273-9.993c-.398-.199-2.354-1.162-2.72-1.294-.364-.133-.63-.199-.895.199-.265.398-1.03 1.294-1.261 1.56-.232.265-.464.298-.862.1-.398-.2-1.681-.62-3.2-1.977-1.183-1.056-1.981-2.36-2.213-2.758-.232-.398-.025-.613.174-.811.179-.178.398-.464.597-.696.199-.232.265-.398.398-.664.133-.265.066-.497-.033-.696-.1-.199-.895-2.16-1.227-2.957-.323-.775-.65-.67-.895-.682l-.762-.013c-.265 0-.696.1-1.06.497-.364.398-1.393 1.362-1.393 3.322s1.426 3.853 1.625 4.118c.199.265 2.806 4.283 6.796 6.007.95.41 1.691.655 2.269.839.953.303 1.82.26 2.505.158.764-.114 2.354-.962 2.687-1.891.332-.929.332-1.726.232-1.891-.099-.166-.364-.265-.762-.464z" />
        </svg>
      </a>

      <style>{`
        .whatsapp-float {
          position: fixed;
          bottom: 28px;
          right: 28px;
          z-index: 9999;
          background-color: #25D366;
          width: 58px;
          height: 58px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 16px rgba(37, 211, 102, 0.5);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          text-decoration: none;
        }

        .whatsapp-float:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 20px rgba(37, 211, 102, 0.7);
        }

        .whatsapp-float:active {
          transform: scale(0.95);
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;